// ──────────────────────────────────────────────────────────────────────────
// BannerContesto.js — Banner giallo informativo con azioni opzionali.
//
// Pattern UX consolidato in v130 (D106, D109 — stagione vuota,
// filtro a 0 risultati). Estratto in v131 per riuso tra sotto-tab.
// Logica e stili identici all'originale di DiarioStatisticheSintesi.js,
// byte-per-byte.
//
// Props:
//   - messaggio: stringa o ReactNode con il testo informativo
//   - azioni:    array opzionale di {label, onClick} - bottoni a destra
// ──────────────────────────────────────────────────────────────────────────

export default function BannerContesto({ messaggio, azioni }) {
  return (
    <div style={{
      background: "#fef3c7", border: "1px solid #fbbf24",
      borderRadius: 8, padding: "12px 16px",
      display: "flex", alignItems: "center", justifyContent: "space-between",
      gap: 12, flexWrap: "wrap", marginBottom: 16,
    }}>
      <div style={{ fontSize: 13, color: "#78350f" }}>
        <span style={{ marginRight: 6 }}>ⓘ</span>{messaggio}
      </div>
      {azioni && azioni.length > 0 && (
        <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
          {azioni.map((a, i) => (
            <button key={i} onClick={a.onClick} style={{
              background: "#fff", border: "1px solid #fbbf24",
              borderRadius: 6, padding: "5px 10px", fontSize: 12,
              color: "#78350f", cursor: "pointer", fontWeight: 500,
            }}>{a.label}</button>
          ))}
        </div>
      )}
    </div>
  );
}
